/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sub_TransactionsInputs */

const en_settings_sub_transactions = /** @type {(inputs: Settings_Sub_TransactionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transactions`)
};

const id_settings_sub_transactions = /** @type {(inputs: Settings_Sub_TransactionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaksi`)
};

/**
* | output |
* | --- |
* | "Transactions" |
*
* @param {Settings_Sub_TransactionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_transactions = /** @type {((inputs?: Settings_Sub_TransactionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_TransactionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_transactions(inputs)
	return en_settings_sub_transactions(inputs)
});